var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import EditableTextbox from '@/shared/components/editable/EditableTextbox';
import EditableAddress from '@/shared/components/editable/EditableAddress';
import messages from '../legalEntitiesMessages';
var isAddressIncomplete = function (entity) {
    return !entity.street1 || !entity.number || !entity.zipCode || !entity.city || !entity.countryCode;
};
var IdentificationSection = function (_a) {
    var _b;
    var entity = _a.entity, onUpdateName = _a.onUpdateName, onUpdateAddress = _a.onUpdateAddress;
    var intl = useIntl();
    var addressForDisplay = useMemo(function () {
        var _a;
        return ({
            street1: entity.street1,
            street2: entity.street2,
            number: entity.number,
            box: entity.box,
            zipCode: entity.zipCode,
            city: entity.city,
            region: (_a = entity.region) !== null && _a !== void 0 ? _a : null,
            country: entity.countryCode,
        });
    }, [entity]);
    return (_jsxs("div", __assign({ className: "simple-panel control-panel subsection settings-page" }, { children: [_jsx("div", __assign({ className: "panel-title pointer" }, { children: _jsx("span", { children: _jsx(FormattedMessage, __assign({}, messages.Identification)) }) })), _jsxs("div", __assign({ className: "panel-body form-horizontal form-labels-left" }, { children: [_jsxs("div", __assign({ className: "form-group clearfix" }, { children: [_jsxs("label", __assign({ className: "control-label col-md-5 col-sm-3" }, { children: [_jsx(FormattedMessage, __assign({}, messages.Name)), !entity.name && (_jsx("i", { className: "fa fa-exclamation-triangle fa-fw text-danger clickable pull-right", title: intl.formatMessage(messages.msgNameRequired) }))] })), _jsx("div", __assign({ className: "col-md-7 col-sm-9" }, { children: _jsx(EditableTextbox, { value: (_b = entity.name) !== null && _b !== void 0 ? _b : '', onChange: function (val) { return onUpdateName(val); } }) }))] })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsxs("label", __assign({ className: "control-label col-md-5 col-sm-3" }, { children: [_jsx(FormattedMessage, __assign({}, messages.Address)), isAddressIncomplete(entity) && (_jsx("i", { className: "fa fa-exclamation-triangle fa-fw text-danger clickable pull-right", title: intl.formatMessage(messages.msgAddressIncomplete) }))] })), _jsx("div", __assign({ className: "col-md-7 col-sm-9" }, { children: _jsx(EditableAddress, { value: addressForDisplay, onSubmit: onUpdateAddress }) }))] }))] }))] })));
};
export default IdentificationSection;
